import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minuter
      gcTime: 10 * 60 * 1000, // 10 minuter (tidigare cacheTime)
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
